export const OPEN_FILE_EVENT = "rdm:open-file";

export function openFile(url, name) {
  window.dispatchEvent(new CustomEvent(OPEN_FILE_EVENT, { detail: { url, name } }));
}

export async function openBlobFile(fetcher, name) {
  const res = await fetcher();
  openFile(URL.createObjectURL(res.data), name);
}
